export default __webpack_public_path__ + "static/media/charminar.49651012.jpeg";